import styled from "styled-components";
import { color } from "../../shared/styles";

export const NavBar = styled.div`
    padding: 16px 32px 16px 16px;
    display: flex;
    height: 12px;
    gap: 12px;
    background-color: ${color.secondary.GREY_1};
    border-bottom: 1px solid ${color.secondary.BORDER};
`;

export const NotificationButton = styled.div`
    padding: 2px 12px 2px 12px;
    background-color: blue;
`;
